import { theme } from "../theme";

export const toolbarStyles = () => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '20px 2%',
    padding: '30px 0px 30px 30px',
    backgroundColor: theme.palette.primary.white,
    height: 'auto',
    margin: '0',
    borderRadius: '4px 4px 0 0',
    borderBottom: '1px solid rgba(224,224,224,1)',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      gap: '12px 2%',
      justifyContent: 'flex-start',
      padding: '16px 16px',
      "& h2": {
        width: '20%',
        textAlign: 'start',
        fontSize: '1.25rem',
      },
    },

    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      gap: '12px 2%',
      justifyContent: 'center',
      padding: '16px 16px',
      "& h2": {
        width: '100%',
        textAlign: 'start',
        fontSize: '1.25rem',
      },
    },
  },
  searchBox: {
    width: '375px',
    '& .MuiOutlinedInput-root': {
      color: theme.palette.secondary.black,
      fontSize: '1.25rem',
      padding: '0 12px',
      height: '56px',
      width: '100%',
      '&:hover': {
        border: 'none',
      },
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiOutlinedInput-root': {
        color: theme.palette.secondary.black,
        fontSize: '1rem',
        padding: '0 12px',
        height: '40px',
        width: '100%',
        '&:hover': {
        border: 'none',
      },
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '69%',
    },
  },
  searchBoxSm: {
    [theme.breakpoints.down('md')]: {
      width: '50%'
    },
  },
  gridToolbarField: {
    display: 'flex',
    alignItems: 'start',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0px',
      justifyContent: 'center'
    },
  },
});
